import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme, darkTheme } from '../theme';
import { useTheme } from './ThemeProvider';

/**
 * MuiThemeProvider - Connects the custom ThemeProvider's dark mode state
 * with Material UI's theming system
 */
export const MaterialThemeProvider: React.FC<{ children: React.ReactNode }> = ({ 
  children 
}) => {
  // Get isDarkMode from our custom ThemeProvider
  const { isDarkMode } = useTheme();
  
  // Use the appropriate MUI theme based on dark mode state
  const currentTheme = isDarkMode ? darkTheme : theme;
  
  return (
    <MuiThemeProvider theme={currentTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};
